import {
  Component
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ReactiveFormsModule
} from '@angular/forms';

import {
  MatInputModule
} from '@angular/material/input';

import { LineCellBaseComponent }
from '../line-cell-base/line-cell-base.component';

@Component({
  selector: 'app-line-cell-money',

  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule
  ],

  templateUrl:
    './line-cell-money.component.html'
})
export class LineCellMoneyComponent
extends LineCellBaseComponent {

  onBlur(): void {

    const value =
      Number(
        this.control.value || 0
      );

    this.control.setValue(
      value.toFixed(2),
      {
        emitEvent: true
      }
    );
  }
}